import script from "./TelegramChatSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TelegramChatSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TelegramChatSkeleton.vue?vue&type=style&index=0&id=83896880&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83896880"]])

export default __exports__